import React, { useState } from 'react';
import RecommendationsItem from '../RecommendationsItem.js'; // Adjust the import path as needed
const styleByStatus = (status) => {
    switch (status) {
        case "new":
            return "approved";
        case "approved":
            return "process";
        case "process":
            return "end";
        case "end":
            return "process";
        default:
            return status;
    }
};
const TaskRelations = ({ data, setFilter, ...props }) => {
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const toggleDeleteModal = (id) => {
        setDeleteVisible(prev => !prev);
        setDeleteId(id);
    };

    return (
        <>
            {data?.parent_task_details && (
                <div>
                    <div className='line-blue'/>
                    <span className="message-heading">Գլխավոր առաջադրանքներ</span>
                    <div className="child-tasks">
                        <RecommendationsItem
                            toLink={`/main_employee/tasks/${data?.parent_task_details.id}`}
                            item={data?.parent_task_details}
                            modalShow={() => toggleDeleteModal(data?.parent_task_details.id)}
                            getTaskData={() => {}}

                            {...props}
                            color={styleByStatus(data?.parent_task_details.status)}
                        />
                    </div>
                </div>
            )}

            {data?.child_tasks?.length > 0 && (
                <div>
                    <div className='line-blue'/>
                    <span className="message-heading">Ենթաառաջադրանքներ</span>
                    <div className="child-tasks">
                        {data?.child_tasks.map((item, index) => (
                            <RecommendationsItem
                                key={index}
                                child_tasks={true}
                                toLink={`/main_employee/tasks/${item.id}`}
                                item={item}
                                modalShow={() => toggleDeleteModal(item.id)}
                                getTaskData={() => {}}

                                {...props}
                                color={styleByStatus(item.status)}
                            />
                        ))}
                    </div>
                </div>
            )}

            {data?.parent_child_tasks && data?.parent_child_tasks.length > 1 && (
                <div>
                    <div className='line-blue'/>
                    <span className="message-heading">Գլխավոր առաջադրանքի այլ ենթաառաջադրանքները</span>
                    <div className="child-tasks">
                        {data?.parent_child_tasks.map((item, index) => {
                            if (item.id === data?.id) return null;
                            return (
                                <RecommendationsItem
                                    key={index}
                                    toLink={`/main_employee/tasks/${item.id}`}
                                    item={item}
                                    modalShow={() => toggleDeleteModal(item.id)}
                                    getTaskData={() => {}}
                                    {...props}
                                    color={styleByStatus(item.status)}
                                />
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default TaskRelations;
